import axios from 'axios';

import { simpleProjectServiceUrl } from '../../config/environment';
import { UserProfile } from '../simple-project-service/project-service.types';

export const getCurrentUserProfile = async (): Promise<UserProfile> => {
  const response = await axios.get(
    `${simpleProjectServiceUrl}/api/v1/identity-data-hub/current-user-profile`,
  );
  const { data = {} } = response || {};
  Object.keys(data).forEach((key) => {
    if (data[key] === null) {
      data[key] = '';
    }
  });
  return data;
};
